import { render, staticRenderFns } from "./FarbkarteDetail.vue?vue&type=template&id=4170533a&scoped=true&"
import script from "./FarbkarteDetail.vue?vue&type=script&lang=js&"
export * from "./FarbkarteDetail.vue?vue&type=script&lang=js&"
import style0 from "./FarbkarteDetail.vue?vue&type=style&index=0&id=4170533a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170533a",
  null
  
)

export default component.exports